import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { Download, Printer } from "lucide-react";
import "../assets/transactions/ViewStatement.css";

const ViewStatement = () => {
  const [orientation, setOrientation] = useState("portrait");
  const { state } = useLocation();
  const componentRef = useRef(null);

  const { selectedAccount, transactions, profile } = state || {};

  if (!state) {
    return <p>No data available</p>;
  }

  const handleDirectPrint = async () => {
    const input = componentRef.current;
    const printSection = document.querySelector(".statement-print-options");
    if (printSection) printSection.style.display = "none";

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff",
    });

    if (printSection) printSection.style.display = "block";

    const imgData = canvas.toDataURL("image/png");
    const isLandscape = orientation === "landscape";

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Statement</title>
          <style>
            @page { size: ${
              isLandscape ? "150mm 105mm" : "105mm 150mm"
            }; margin: 5mm; }
            body { margin: 0; padding: 0; }
            .passbook-img { 
              max-width: 100%; 
              max-height: 100%; 
              object-fit: contain; 
              display: block; 
            }
          </style>
        </head>
        <body>
          <img class="passbook-img" src="${imgData}" />
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <div className="statement-print-page">
      {/* <p><strong>Customer:</strong> {selectedAccount.customerName}</p>
      <p><strong>Account No:</strong> {selectedAccount.accountNumber}</p>
      <p><strong>Branch:</strong> {profile?.branchName}</p> */}
      <div ref={componentRef}>
         <div
          className={`statement-wrapper ${
            orientation === "landscape" ? "horizontal" : "vertical"
          }`}
        >
        <table border="1" width="100%">
          <thead>
            <tr>
              {/* <th>Date</th>
              <th>Type</th>
              <th>Debit</th>
              <th>Credit</th>
              <th>Balance</th> */}
              <th>SN</th>
              {/* <th>Customer ID</th>
              <th>Account No</th> */}
              <th>Txn Type</th>
              <th>Interest Amount</th>
              <th>Payment Mode</th>
              <th>Current Balance</th>
              <th>Date</th>
              <th>Narration</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((txn, i) => (
              <tr key={i}>
                {/* <td>{new Date(txn.txnDate).toLocaleDateString()}</td>
                <td>{txn.txnType}</td>
                <td>{txn.txnType === "WITHDRAW" ? "₹"+txn.amount : "-"}</td>
                <td>{txn.txnType === "DEPOSIT" ? "₹"+txn.amount : "-"}</td>
                <td>₹{txn.balanceAfterTxn}</td> */}
                <td>{i + 1}</td>
                  {/* <td>{txn.customerId}</td>
                  <td>{selectedAccount.accountNo||selectedAccount?.accountNumber}</td> */}
                  <td>{txn.txnType}</td>
                  <td>₹{txn.amount}</td>
                  <td>{txn.paymentMode}</td>
                  <td>₹{txn.balanceAfterTxn}</td>
                  <td>
                    {txn.txnDate
                      ? new Date(txn.txnDate).toLocaleDateString("en-GB")
                      : "-"}
                  </td>
                  <td>{txn.remarks || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>

      {/* Print Options */}
      <div className="statement-print-options">
        <h3>🖨️ Print Options</h3>

        <div className="stetement-print-option-row">
          <p>Page Orientation :</p>
          <label>
            <input
              type="radio"
              name="orientation"
              checked={orientation === "portrait"}
              onChange={() => setOrientation("portrait")}
            />{" "}
            Vertical
          </label>
          <label>
            <input
              type="radio"
              name="orientation"
              checked={orientation === "landscape"}
              onChange={() => setOrientation("landscape")}
            />{" "}
            Horizontal
          </label>
        </div>

        {/* <button className="stetement-print-btn" onClick={generatePDF}>
          <Download size={15} /> Download PDF
        </button> */}
        <button
          style={{ marginLeft: "10px" }}
          className="stetement-print-btn"
          onClick={handleDirectPrint}
        >
          <Printer size={15} /> Print Statement
        </button>
      </div>
      {/* <button onClick={handlePrint} style={{ marginTop: 20 }}>
        Print Now
      </button> */}
    </div>
  );
};

export default ViewStatement;
